"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PdfDownload = function PdfDownload(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.29,18,18,19.29V14.5a.5.5,0,1,0-1,0v4.79L15.71,18a.5.5,0,1,0-.71.71l2.15,2.15a.5.5,0,0,0,.71,0L20,18.71a.5.5,0,1,0-.71-.71Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "11 1 11 6 16 6 11 1",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.29,8.68H3.53V10h.76a.7.7,0,0,0,.7-.7A.68.68,0,0,0,4.29,8.68Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.52,8.65H6.8v2.8h.73a1.4,1.4,0,0,0,0-2.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,10V5.5a.5.5,0,0,0-.15-.35l-5-5A.5.5,0,0,0,11.5,0H.5A.5.5,0,0,0,0,.5v21a.5.5,0,0,0,.5.5h11A7.48,7.48,0,0,1,17,10ZM11,1l5,5H11Zm-.68,7.23a.1.1,0,0,1, .1-.1h2.2a.1.1,0,0,1,.1.1v.31a.1.1,0,0,1-.1.1H10.89V9.91h1.47a.11.11,0,0,1,.1.1v.3a.11.11,0,0,1-.1.1H10.89v1.45a.11.11,0,0,1-.1.1h-.36a.1.1,0,0,1-.1-.1Zm-6, 2.35h-.8v1.29a.11.11,0,0,1-.1.1H3.07a.1.1,0,0,1-.1-.1V8.23a.1.1,0,0,1,.1-.1H4.32a1.23,1.23,0,1,1,0,2.45ZM7.6,12H6.33a.1.1,0,0,1-.1-.1V8.23a.1.1,0, 0,1,.1-.1H7.6A1.92,1.92,0,1,1,7.6,12Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.5,11A6.5,6.5,0,1,0,24,17.5,6.5,6.5,0,0,0,17.5,11ZM20,18.71l-2.15,2.15a.5.5,0,0,1-.71,0L15,18.71a.5.5,0,1,1,.71-.71L17,19.29V14.5a.5.5,0,1,1,1,0v4.79L19.29, 18a.5.5,0,1,1,.71.71Z"
  }));
};

var _default = PdfDownload;
exports["default"] = _default;